import React from 'react';
import './Consultancy.css';

const Consultancy = () => {
  return (
    <section className="consultancy-section fade-in" id="consultancy">
      <h2 className="consultancy-heading">PROVIDING TECHNICAL CONSULTANCY</h2>
      <div className="consultancy-container">
        <div className="consultancy-item left-image">
          <img
            src="/img1.webp"
            alt="Technical Consultancy 1"
            className="consultancy-image"
          />
          <p>
            Partnering with Lattice Labs means you receive{' '}
            <a href="#" className="highlight-link">
              expert technical support at every stage of your project
            </a>
            , ensuring you make informed decisions with confidence. From the start, our Business Developer will work with you to identify requirements, offering insights and recommendations drawn from over 15 years of experience and 300 successful projects. Throughout your project, our Project Managers will become deeply familiar with your product, providing technical guidance that aligns with your business goals and helping you navigate any challenges.
          </p>
        </div>
        <div className="consultancy-item right-image">
          <img
            src="/img2.webp"
            alt="Technical Consultancy 2"
            className="consultancy-image"
          />
          <p>
            Even if you work with a small team of Lattice Labs engineers, you benefit from our collective expertise. Our{' '}
            <a href="#" className="highlight-link">
              multi-skilled squads
            </a>{' '}
            collaborate closely, meaning that if our Back-End developer is faced with a challenge, this will be supported from one of our Data-Scientists to overcome it.
          </p>
        </div>
        <div className="consultancy-item left-image">
          <img
            src="/img3.webp"
            alt="Technical Consultancy 3"
            className="consultancy-image"
          />
          <p>
            At Lattice Labs, we drive Digital Acceleration with a lean, cost-efficient mindset.{' '}
            <a href="#" className="highlight-link">
              We focus on doing the right things
            </a>
            , nothing more, nothing less.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Consultancy;
